export const LocationWithHierarchyTypeCodes = {
  YARD: 'Yard',
  SCALE: 'Scale',
  DOOR: 'Door',
  PARKINGAREA: 'ParkingArea',
  PARKINGSPOT: 'ParkingSpot',
  GATE: 'Gate',
  DOCKAREA: 'DockArea',
};

export type LocationWithHierarchy =
  (typeof LocationWithHierarchyTypeCodes)[keyof typeof LocationWithHierarchyTypeCodes];

// Define parent-child relationships between location types
export const LOCATION_TYPE_PARENT_MAP: Record<string, string[]> = {
  [LocationWithHierarchyTypeCodes.YARD]: [],
  [LocationWithHierarchyTypeCodes.PARKINGAREA]: [LocationWithHierarchyTypeCodes.YARD],
  [LocationWithHierarchyTypeCodes.PARKINGSPOT]: [
    LocationWithHierarchyTypeCodes.PARKINGAREA,
    LocationWithHierarchyTypeCodes.SCALE,
  ],
  [LocationWithHierarchyTypeCodes.DOOR]: [LocationWithHierarchyTypeCodes.YARD, LocationWithHierarchyTypeCodes.DOCKAREA],
  [LocationWithHierarchyTypeCodes.GATE]: [LocationWithHierarchyTypeCodes.YARD],
  [LocationWithHierarchyTypeCodes.SCALE]: [LocationWithHierarchyTypeCodes.YARD],
  [LocationWithHierarchyTypeCodes.DOCKAREA]: [LocationWithHierarchyTypeCodes.YARD],
};
